import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from './services/api';
import './Admin.css';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!username || !password) {
            setError('Please enter both username and password.');
            return;
        }

        setLoading(true);
        try {
            const res = await adminLogin(username, password);
            setLoading(false);
            if (res.success && res.token) {
                localStorage.setItem('adminToken', res.token);
                localStorage.setItem('adminUser', JSON.stringify(res.user));
                navigate('/');
            } else {
                setError(res.message || 'Invalid admin credentials.');
            }
        } catch (err) {
            setLoading(false);
            setError('Could not connect to backend server. Ensure node server is running on port 5000.');
        }
    };

    return (
        <div className="admin-login-wrapper">
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <h2>bs clads Admin Portal</h2>
                    <p>Enter your administrative credentials to access the management dashboard.</p>
                </div>

                {error && (
                    <div className="admin-alert admin-alert-danger m-b15">
                        <i className="fa fa-exclamation-circle m-r10" />
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="admin-login-form">
                    <div className="admin-form-group">
                        <label>Username / Email</label>
                        <div className="input-with-icon">
                            <i className="fa fa-user" />
                            <input
                                type="text"
                                className="admin-input"
                                placeholder="e.g. admin or rajvikramdas@bsclads.com"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="admin-form-group">
                        <label>Password</label>
                        <div className="input-with-icon" style={{ position: 'relative' }}>
                            <i className="fa fa-lock" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className="admin-input"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{ paddingRight: '40px' }}
                                required
                            />
                            <i
                                className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '14px',
                                    left: 'auto',
                                    cursor: 'pointer',
                                    color: '#94a3b8',
                                    fontSize: '16px',
                                    zIndex: 10
                                }}
                                title={showPassword ? 'Hide Password' : 'Show Password'}
                            />
                        </div>
                    </div>

                    <button type="submit" className="admin-btn admin-btn-primary w-100 m-t15" disabled={loading}>
                        {loading ? <span>Connecting...</span> : <span>Login to Dashboard &rarr;</span>}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
